import { render, staticRenderFns } from "./LandlordSuccessPage.vue?vue&type=template&id=58d7ea8d"
import script from "./LandlordSuccessPage.vue?vue&type=script&lang=js"
export * from "./LandlordSuccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports